import { render, staticRenderFns } from "./serviceProviderItem.vue?vue&type=template&id=f1c0cdee&"
import script from "./serviceProviderItem.vue?vue&type=script&lang=ts&"
export * from "./serviceProviderItem.vue?vue&type=script&lang=ts&"
import style0 from "./serviceProviderItem.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports